/** @module SiteAdmin/Project/NewProjectLineItemWizard */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/underscore",
	"csi/table/New",
	"csi/wizard/ActionControllerMixin",
	"csi/xml",
	"csi/xml/Query"
], function (declare, lang, _, New, ActionControllerMixin, xml, Query) {

	return declare([New, ActionControllerMixin], {
		idWizardResource: "NewProjectLineItemWizard",

		/**
		 * @override
		 * Disable finish button
		 */
		disableFinish: function (wizard, page, index) {
			return index == 0 || !this.m_formData.getSelectedNodes().length > 0;
		},

		/**
		 * @override
		 * Filter nodes based on the selected product type
		 */
		getWizardViewQuery: function (wizard, view, index) {
			let q = this.inherited(arguments);
			if (index == 1) {
				const type = this.m_formData.getFieldValue("ProductType").split(":").pop();
				if (!type) {
					return q;
				}
				q = new Query();
				q.Node(xml.PROP_TYPE, xml.OP_EQUALS, type);
				if (type === "Style") {
					q.Attr("IsTemplate", xml.OP_EQUALS, false);
				} else if (type === "Material") {
					q.Attr("Hidden", xml.OP_EQUALS, false);
					q.Attr("Special", xml.OP_EQUALS, false);
				} else if (type === "FormulatedMaterial") {
					q.Attr("Special", xml.OP_EQUALS, false);
				}
			}
			return q;
		},

		/**
		 * @override
		 * Pass data into the next page
		 */
		onNextPage: function (wizard, currentPage, nextPage, bFinish) {
			const fd = this.m_formData;
			let bRefresh = false;
			if (wizard.getIndexOfPage(nextPage) == 1) {
				fd.resetSelections();
				bRefresh = true;
			}

			return (fd && !bFinish) ? wizard.setFormDataToPage(nextPage, fd, bRefresh) : null;
		},

		/**
		 * @override
		 * ProductType is marked to be taken care on the server side
		 */
		toWriterRequest: function (fd) {
			this.m_formData.getFieldValue("ProductType", true);
			return this.inherited(arguments);
		},
	});
});
